<template lang="pug">
  v-card(flat)
    h4.pa-0(v-if="item.name") {{ item.name }}
    p.text-caption(v-if="item.description") {{ item.description }}
    .text-caption Вопросы:
    v-list
      v-list-item.pl-0(
        v-for="question in item.questions"
      )
        v-list-item-content
          v-list-item-title.text-body-2: strong {{ question.name }}
          .text-caption {{ question.description }}
          div(v-if="item.answers") Ответ:
            span.ml-2(v-for="answer in getAnswers(question)") {{ answer }}

</template>
<script>

export default {
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return {
    };
  },
  methods: {
    getAnswers(question) {
      const { answer, variants } = this.item.answers.find(
        ({ question_id: id }) => id === question.id,
      ) || { answer: null };
      if (question.type === 5) return variants.map(({ name }) => name);
      return [answer];
    },
  },
};
</script>
